import { FilterTogglesOptionModel } from '@lerna-core';

export const getLinkedFilterOptions = (
  options: FilterTogglesOptionModel[],
  isSphereFilterSelected: boolean
): FilterTogglesOptionModel[] =>
  options
    .filter((option) => option.isVisible && option.isActive)
    .map((option) => ({
      ...option,
      isDisabled: isSphereFilterSelected ? !option.isLinked : false,
    }))
    .sort((a, b) => (a.isDisabled === b.isDisabled ? 0 : a.isDisabled ? 1 : -1))
    .sort((a, b) => (a.checked === b.checked ? 0 : a.checked ? -1 : 1));
